import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Fld from "../../components/common/Fld";
import Dlg from "../../components/common/Dlg";
import { ABt, filt } from "../AdminUI";

export default function CertsTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("certifications", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("certifications", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 13, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 9, padding: "11px 15px" }}>
        <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>Certifications scroll in the footer ticker on all pages.</p>
        <ABt variant="orange" onClick={() => { setForm({ code: "", label: "", ic: "🏅", desc: "", color: "#15803d" }); setModal(true); }}>+ Add</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 12 }}>
        {filt(db.certifications || [], ["code", "label"], srch).map(c => (
          <div key={c.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "15px 16px", display: "flex", gap: 12, alignItems: "center", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <div style={{ width: 54, height: 54, borderRadius: 11, background: c.color + "14", border: "2px solid " + c.color + "33", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, flexShrink: 0 }}>{c.ic}</div>
            <div style={{ flex: 1, minWidth: 0 }}><div style={{ fontSize: 13.5, fontWeight: 800, color: c.color, marginBottom: 2 }}>{c.code}</div><div style={{ fontSize: 12.5, fontWeight: 700, color: C.blue, marginBottom: 2 }}>{c.label}</div><div style={{ fontSize: 11.5, color: "#64748b" }}>{c.desc}</div></div>
            <div style={{ display: "flex", gap: 5, flexShrink: 0 }}><ABt onClick={() => { setForm({ ...c }); setModal(true); }}>Edit</ABt><ABt variant="red" onClick={() => del(c.id)}>Del</ABt></div>
          </div>
        ))}
      </div>

      {modal && <Dlg title={form.id ? "Edit Certification" : "Add Certification"} onClose={close}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="ISO Code" value={form.code || ""} onChange={fs("code")} /><Fld label="Icon (emoji)" value={form.ic || "🏅"} onChange={fs("ic")} /></div>
        <Fld label="Label" value={form.label || ""} onChange={fs("label")} />
        <Fld label="Description" value={form.desc || ""} onChange={fs("desc")} rows={2} />
        <Fld label="Accent Color" value={form.color || "#15803d"} onChange={fs("color")} type="color" />
        {form.code && (
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 9, padding: 13, marginBottom: 10 }}>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 8, fontWeight: 700, textTransform: "uppercase" }}>Preview</div>
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <div style={{ width: 46, height: 46, borderRadius: 10, background: (form.color || "#15803d") + "14", border: "2px solid " + (form.color || "#15803d") + "33", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{form.ic || "🏅"}</div>
              <div><div style={{ fontSize: 13, fontWeight: 800, color: form.color || "#15803d" }}>{form.code}</div><div style={{ fontSize: 12, color: C.blue, fontWeight: 600 }}>{form.label || "–"}</div><div style={{ fontSize: 11, color: "#64748b" }}>{form.desc || "–"}</div></div>
            </div>
          </div>
        )}
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Add"} Certification</ABt>
      </Dlg>}
    </>
  );
}
